module.exports = __webpack_public_path__ + "img/numbers.e57acb04.png";